import LocalStorageImpl from '../../serviceImpl/LocalStorageImpl';

const getcredentialsUseCase = () => LocalStorageImpl.getCredentials();

export default getcredentialsUseCase;